import { Component, EventEmitter, Input, Output, QueryList, ViewChildren } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { Survey, SurveyService, WriterAnswers } from '../services/survey.service';
import { SurveyQuestionComponent } from '../survey-question/survey-question.component';
import { countries } from '../countries';

@Component({
    selector: 'ell-survey-writer',
    standalone: true,
    imports: [RouterLink, SurveyQuestionComponent, FormsModule],
    templateUrl: './survey-writer.component.html',
    styleUrl: './survey-writer.component.scss'
})
export class SurveyWriterComponent {
    error = '';

    sexOptions = [
        $localize`Male`,
        $localize`Female`,
        $localize`Other`
    ];

    maritalOptions = [
        $localize`Married`,
        $localize`In a registered partnership`,
        $localize`Divorced / separated`,
        $localize`Widowed`,
        $localize`Other (please give further information)`
    ];

    deathOptions = [
        $localize`Natural death through illness`,
        $localize`Ended their own life with medical help or under medical supervision (including refusal of food and drink)`,
        $localize`Euthanasia (i.e. administered directly by a doctor)`,
        $localize`Ended their own life without medical help or supervision (please give further information )`,
        $localize`Other (please give further information )`
    ];

    countryOptions = [
        ...countries,
        $localize`Other`
    ];

    answers: WriterAnswers = {
        birthMonth: '',
        birthDateApproximate: false,
        birthCountry: '',
        birthSex: '',
        ethnicity: '',
        firstLanguages: '',
        otherLanguages: '',
        genderDetails: '',
        marital: '',
        occupation: '',
        residencyCountry: '',
        deathCountry: '',
        deathMonth: '',
        deathDateApproximate: false,
        deathMethod: '',
        deathDetails: ''
    };

    page = 1;

    @Input()
    survey?: Survey;

    @Output()
    complete = new EventEmitter<WriterAnswers>();

    @ViewChildren(SurveyQuestionComponent)
    questions!: QueryList<SurveyQuestionComponent<any>>;

    constructor(private surveyService: SurveyService) {
    }

    next() {
        this.complete.emit(this.answers);
    }

    ngAfterViewChecked(): void {
        if (this.survey) {
            this.surveyService.registerQuestions(this.survey, this.questions);
        }
    }

}
